import React, { useState,useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Blog from "../../components/blogFooter/blogFooter";
import HeaderForJuristicAccounting from "../../components/header/forJuristicAccounting/headerForJuristicAccounting";
import Image from "../../components/image";
import { asset } from '../../helpers/dom.helper';
import './style.scss';

import { Media, MediaContextProvider } from "../../media";
import Guarantee from "../../pages/Home/guaranteeHome";
import RegisterHome from "../../pages/Home/registerHome";

function ForJuristicAccounting(props) {

  const { t } = useTranslation(['translation', 'forJuristicAccounting'])
  const [showMores, setShowMores] = useState([false, false])
  const [metaText, setMetaText] = useState()
  const [titleHead, setTitleHead] = useState()

  function onReadMore(index) {
    showMores[index] = !showMores[index]
    setShowMores([...showMores])
  }

  const getMetaTitle = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const type = urlParams.get('type')

  let meta  =""
  let title =""

  if(type){
    switch(type) {
      case "condominium":
        meta = "โปรแกรมบัญชีสำหรับคอนโดของเรา มาพร้อมฟีเจอร์ที่จัดการบัญชีได้อย่างมีประสิทธิภาพ ส่งใบแจ้งหนี้ผ่านระบบ รองรับการชำระเงินหลายช่องทาง ระบบตรวจสอบสลิปด้วย AI และอื่นๆ"
        title = "โปรแกรมบัญชีนิติบุคคลสำหรับคอนโด | Silverman"
        break;
      case "online":
        meta = "โปรแกรมบัญชีออนไลน์ (Accounting Software) ที่ครอบคลุมทุกฟังก์ชัน เช่น ดูบัญชีรายวัน บัญชีแยกประเภท งบแสดงฐานะการเงิน ระบบทวงหนี้จากลูกบ้านอัตโนมัติ เป็นต้น"
        title = "โปรแกรมบัญชีออนไลน์สำหรับบริหารนิติบุคคล | Silverman"
        break;
      case "village":
        meta = "โปรแกรมบัญชีหมู่บ้านจัดสรรของ Silverman ช่วยบริหารงานบัญชีอย่างมีประสิทธิภาพ พร้อมด้วยฟังก์ชั่นการจัดการบัญชี-การเงินที่ครบครัน ตรวจสอบง่าย และช่วยลดเวลาทำงาน"
        title = "โปรแกรมบัญชีนิติบุคคลสำหรับหมู่บ้านจัดสรร | Silverman"
      default:
    }
    setMetaText(meta)
    setTitleHead(title)
  }
  }

  useEffect(() => {
    getMetaTitle()
  }, [metaText,titleHead])

  return (
    <>
      {titleHead && metaText && (
        <Helmet>
          <title>{titleHead}</title>
          <meta name="description" content={metaText} />
          <meta name="keywords" content={t("forJuristicAccounting:metaKeyWord")} />
          <link rel="canonical" href="https://silverman.app/for-juristic-accounting" />
        </Helmet>
      )}

      {/* <ScrollToTopOnMount /> */}
      <HeaderForJuristicAccounting {...props} />

      <div className="for-juristic-accounting">
        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-5 d-md-block d-none text-center">
                <Image
                  src={asset('/images/autoReconciling/Auto-Recon.webp')}
                  alt="auto-reconciling" className="img-fluid" />
              </div>
              <div className="col-md-7 mb-4 text-left mt-2">
                <h1>{t("forJuristicAccounting:Auto-Reconciling")}</h1>
                <h2>(Auto-Reconciling)</h2>
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Say goodbye to the hassle of paperwork and human errors.")
                }} />
              </div>
              <div className="col-md-5 d-sm-block d-md-none text-center">
                <Image
                  src={asset('/images/autoReconciling/Auto-Recon.webp')}
                  alt="auto-reconciling" className="img-fluid mt-2" />
                <p className="text-center">Auto-Reconciling</p>
              </div>
            </div>
          </div>
        </div>
        <div className="box-margin-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left mb-5 mb-md-0">
                <h1>{t("forJuristicAccounting:Intelligent Slip Verification Technology")}</h1>
                <h2>(Auto-Reconciling)</h2>
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Intelligent Slip Verification system is designed to minimize redundant juristic accounting tasks.")
                }} />
              </div>
              <div className="col-md-6 text-center">
                <Image
                  src={asset('/images/intelligentSlipVerification/IntelligentSlipVerification-2.webp')}
                  alt="int-slip" className="img-fluid mb-2" />
              </div>


            </div>
          </div>
        </div>
        <div className="box-margin-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image
                  src={asset('/images/forJuristic/auto-revenue.svg')}
                  alt="auto-revenue" className="img-fluid" />
                <p className="mt-0">Automatic Revenue Recognition System</p>
              </div>
              <div className="col-md-6 text-left">
                <h1>{t("forJuristicAccounting:Automatic Revenue Recognition System")}</h1>
                <h2>(Automatic Revenue Recognition System)</h2>
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Say goodbye to complicated Excel formulas. " +
                    "Save your time and let Silverman handles your accounting works.")
                }} />
              </div>
              <div className="col-md-6 d-md-none">
                <Image
                  src={asset('/images/forJuristic/auto-revenue.svg')}
                  alt="auto-revenue" className="img-fluid mb-2" />
                <p className="text-center">Automatic Revenue Recognition System</p>
              </div>
            </div>
          </div>
        </div>

        <div className="box-margin-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left mb-5 mb-md-0">
                <h1>AI Smart Detection</h1>
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Reduce human error and increase " +
                    "accuracy with our AI-powered accounting software.")
                }} />
              </div>
              <div className="col-md-6 text-center">
                <Image
                  src={asset('/images/forJuristic/ai-smart.webp')}
                  alt="ai-smart" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box-margin-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image src={asset('/images/forJuristic/report.webp')}
                  alt="report" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left mb-5 mb-md-0">
                <h1>{t("forJuristicAccounting:Conduct an examination of accounts in One Click")}</h1>
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Put an end to the " +
                    "complication of accounting works.")
                }} />
              </div>
              <div className="col-md-6 d-md-none">
                <Image src={asset('/images/forJuristic/report.webp')}
                  alt="report" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box-margin-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left mb-5 mb-md-0">
                <h1 dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Automatically " +
                    "connect data between Accrued Revenue and Expenditure and General Ledger")
                }} />
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Silverman " +
                    "Online Accounting System ensures error prevention and avoids redundant works.")
                }} />
              </div>
              <div className="col-md-6 text-center">
                <Image src={asset('/images/forJuristic/gl.webp')}
                  alt="gl" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image src={asset('/images/forJuristic/debt.webp')}
                  alt="debt" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left mb-5 mb-md-0">
                <h1>{t("forJuristicAccounting:AI Smart Overdue Payment Reminder")}</h1>
                <h2>(AI Smart Overdue Payment Reminder)</h2>
                <p dangerouslySetInnerHTML={{
                  __html: t("forJuristicAccounting:Our Overdue Payment " +
                    "Reminder makes Common Area Fees Collection more effective.")
                }} />
              </div>
              <div className="col-md-6 d-md-none">
                <Image src={asset('/images/forJuristic/debt.webp')}
                  alt="debt" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left mb-5 mb-md-0">
                <h1>{t("forJuristicAccounting:Increasing Productivity and Reducing Costs")}</h1>
                <p>{t("forJuristicAccounting:Silverman utilizes AI technology to avoid redundant " +
                  "tasks and enhance the services.")}<br />
                  <span className={`more ${showMores[0] ? 'd-block' : ''}`}>
                    <p className="list">
                      {t("forJuristicAccounting:Sending invoice and receipt through application")}<br />
                      {t("forJuristicAccounting:Replacing paper newsletter with online notification")}<br />
                      {t("forJuristicAccounting:Reducing the use of a logbook by signing as an acceptance of mail or parcel through application")}<br />
                      {t("forJuristicAccounting:Minimizing man-hour and workforce by using full-featured accounting software")}<br />
                      {t("forJuristicAccounting:Avoiding unnecessary tasks and improving services")}<br />
                      {t("forJuristicAccounting:Cutting stationary costs and increasing cash flow")}<br />
                      {t("forJuristicAccounting:Paying only for monthly subscription with no additional fees for software license, server or maintenance.")}
                    </p>
                  </span>
                </p>

                <span className="read-more" onClick={() => onReadMore(0)}>{t(!showMores[0] ? "Read More" : "Read Less")}</span>
              </div>
              <div className="col-md-6 text-center">
                <Image src={asset('/images/forJuristic/cost.webp')}
                  alt="cost" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image
                  src={asset('/images/forJuristic/tax-online.webp')}
                  alt="tax-online" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left">
                <h1>{t("forJuristicAccounting:Support the e-filing system")}</h1>
                <p>{t("forJuristicAccounting:Start using Silverman today and turn complicated " +
                  "and time consuming tax filing into yesterday's news.")}<br />
                  <span className={`more ${showMores[1] ? 'd-block' : ''}`}>
                    <p>
                      {t("forJuristicAccounting:Silverman is ready to connect to filing system of the Revenue Department.")}
                    </p>
                  </span>
                </p>

                <span className="read-more" onClick={() => onReadMore(1)}>{t(!showMores[1] ? "Read More" : "Read Less")}</span>
              </div>
              <div className="col-md-6 d-md-none">
                <Image
                  src={asset('/images/forJuristic/tax-online.webp')}
                  alt="tax-online" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>
{/* 
        <div className="function-niti">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h1>{t("forJuristicAccounting:Essential Property Management Accounting Tools")}</h1>
              </div>
            </div>
            <div className="row p-4">
              <div className="col-md-6">
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/send-invoice.webp')}
                    alt="send-icon" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Sending bills to residents via application") }} />
                </div>
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/graph.webp')}
                    alt="graph" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Show list of residents in debt") }} />
                </div>
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/summary.webp')}
                    alt="summary" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Automatically calculating late fees (by Month)") }} />
                </div>
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/permission-for-niti.webp')}
                    alt="permission-for-niti" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Assign access to a staff") }} />
                </div>
              </div>

              <div className="col-md-6">
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/create-invoice.webp')}
                    alt="create-invoice" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Issue an invoice for Cross Bank Bill Payment") }} />
                </div>
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/daily-journal.webp')}
                    alt="daily-journal" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:More accurate by auditing") }} />
                </div>
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/asset.webp')}
                    alt="asset" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Keeping record of assets") }} />
                </div>
                <div className="icon-description">
                  <Image
                    src={asset('/images/forJuristic/online-accounting.webp')}
                    alt="online-accounting" />
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Online Accounting System") }} />
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="function-niti">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h1>{t("forJuristicAccounting:Essential Property Management Accounting Tools")}</h1>
              </div>
            </div>
            <div className="row p-4">
              <div className="col-md-6">
                <div className="icon-description">
                  <div className='icon-desc'>
                  <Image
                    src={asset('/images/forJuristic/send-invoice.webp')}
                    alt="send-icon" />
                  </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Sending bills to residents via application") }} />
                </div>
                <div className="icon-description">
                <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/graph.webp')}
                    alt="graph" />
                </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Show list of residents in debt") }} />
                </div>
                <div className="icon-description">
                <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/summary.webp')}
                    alt="summary" />
                </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Automatically calculating late fees (by Month)") }} />
                </div>
                <div className="icon-description">
                <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/permission-for-niti.webp')}
                    alt="permission-for-niti" />
                    </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Assign access to a staff") }} />
                </div>
              </div>

              <div className="col-md-6">
                <div className="icon-description">
                <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/create-invoice.webp')}
                    alt="create-invoice" />
                  </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Issue an invoice for Cross Bank Bill Payment") }} />
                </div>
                <div className="icon-description">
                  <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/daily-journal.webp')}
                    alt="daily-journal" />
                  </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:More accurate by auditing") }} />
                </div>
                <div className="icon-description height-100">
                <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/asset.webp')}
                    alt="asset" />
                    </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Keeping record of assets") }} />
                </div>
                <div className="icon-description">
                <div className='icon-desc'> 
                  <Image
                    src={asset('/images/forJuristic/online-accounting.webp')}
                    alt="online-accounting" />
                </div>
                  <h3 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Online Accounting System") }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-3"></div>
          <div className="col-6 text-center">
            <div className="register">
              <MediaContextProvider>
                  <Media greaterThanOrEqual="md">
                      <RegisterHome />
                  </Media>
              </MediaContextProvider>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        {/* <div className="guarantee text-center">
              <br></br><br></br> */}
              <Guarantee />
        {/* </div> */}

        <Blog />
      </div>
    </>
  )

}

export default ForJuristicAccounting;
